export const ServerURL = {  
    // PRODUCTION_HOST_URL: `https://ecomapi.kassapos.co.in/`, 
    PRODUCTION_HOST_URL: `https://billing.kassapos.co.in/`, 
    COMPANY_REF_ID: 58,
    Comid: JSON.parse(localStorage.getItem("adminuserid")),
    SubCategoryStatus: 0,
    DeliveryStatus: 0,
    CommonLogoName: "logo (2).jpg",
    CompanyName: "",
    CompanyEmailAddress: "",
    CompanyMobileNumber: "",
    CompanyAddress1: "",
    CompanyAddress2: "",
    CompanyPincode: "",
    TabLogo: "fav.png",
    imagepath: "/Content/images/",
    icons: {
      Dashboardicon: "dashboard.png",
      Offericon: "offer.png",
      Areaicon: "area.png",
      Categoryicon: "category.png",
      SubCategoryicon: "list.png",
      Producticon: "products.png",
      Deliveryicon: "time.png",
      Ordericon: "orders.png",
      Companyicon: "branch.png",
      Customericon: "customers.png",
      Reporticon: "Report.png",
      Couponicon: "couponoffer.png",
      ReferralCouponOfferPanelicon: "referral.png",
      ProductOffericon: "productoffer.png",
      OfferNotificationIcon: "notification.png",
    },
  };
  
  export default ServerURL;
  